import { render, staticRenderFns } from "./MarketShape.vue?vue&type=template&id=bc025380"
import script from "./MarketShape.vue?vue&type=script&lang=js"
export * from "./MarketShape.vue?vue&type=script&lang=js"
import style0 from "./MarketShape.vue?vue&type=style&index=0&id=bc025380&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports